import React, { useContext, useEffect, useState } from 'react';

import safeMeat from '../assets/safeMeat.png';
import line from '../assets/line.png';
import { OrderDetailsContext } from '../context/OrderDetailsContext';

const CallContainer = () => {
  const { orderDetail, orderType } = useContext(OrderDetailsContext);

  const [orderIsCancelled, setOrderIsCancelled] = useState('false');
  const [orderCompleted, setOrderCompleted] = useState(false);

  useEffect(() => {
    // check if delivery is done
    if (orderDetail?.response?.orderState === 'Completed') {
      setOrderCompleted(true);
    }

    if (orderDetail?.response?.orderState === 'Cancelled') {
      setOrderIsCancelled('true');
    }
  }, [orderDetail, orderType]);

  //   Refresh button
  const refreshPage = (e) => {
    window.location.reload(false);
  };

  return (
    <>
      <div className="callContainer">
        {orderIsCancelled === 'true' ? (
          ''
        ) : (
          <>
            {!orderCompleted && (
              <div className="trackerSection">
                <div className="refreshButton">
                  <div className="lastRefreshTimeStamp">
                    Click{' '}
                    <span className="updateLink" onClick={refreshPage}>
                      here
                    </span>{' '}
                    for updated status
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <div className="callInner">
          <hr className="headerHr" />
          <div className="callUsContainer">
            <div className="callText">Call for help</div>
            <a href="tel:1800 103 1310" className="button">
              <button type="button" className="btn btn-success buttonBox">
                <i className="fa fa-phone-alt"></i>
              </button>
            </a>
          </div>
          <hr className="headerHr" />
        </div>
      </div>

      <div className="safeMeatContainerOuter">
        <div className="safeMeatContainer">
          <div className="safemeatImg">
            <img src={safeMeat} alt="" />
          </div>
        </div>

        <div className="safeMeatText">
          Zero Antibiotics | Zero growth Promoters
        </div>
        <div className="lineContainerOuter">
          <div className="line">
            <img src={line} alt="" />
          </div>
        </div>
        <div className="downloadApp">
          <div className="downloadText">Download nandu's app</div>
          <a
            href="https://play.google.com/store/apps/details?id=com.urbanpiper.nandus&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
            className="appLink"
          >
            <i className="ri-android-fill" style={{ color: '#3DDC84' }}></i>
          </a>
          <a
            href="https://apps.apple.com/in/app/nandus-chicken/id1271411991"
            target="_blank"
            rel="noopener noreferrer"
            className="appLink"
          >
            <i className="ri-apple-fill" style={{ color: 'gray' }}></i>
          </a>
        </div>
      </div>
    </>
  );
};

export default CallContainer;
